// extracted by mini-css-extract-plugin
export default {"h":"style_h__vxBvd","h2":"style_h2__1msKF","p2":"style_p2__TRAhz","h3":"style_h3__x20-h"};